export const REQUEST_NEWS_DATA = 'REQUEST_NEWS_DATA';
export const RECEIVE_NEWS_DATA = 'RECEIVE_NEWS_DATA';

export const receiveNewsData = (payload) => ({
  type: RECEIVE_NEWS_DATA,
  payload: payload
});



// WEBPACK FOOTER //
// ./src/actions/newsActions.js